document.addEventListener('DOMContentLoaded', function() {
    const optionsSlider = new Swiper('.options--slider', {
        // Mobile first
        slidesPerView: 4,
        spaceBetween: 10,
        direction: 'horizontal',
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 10,
                spaceBetween: 10
            },
            // when window width is >= 1024px
            992: {
              slidesPerView: 3,
              spaceBetween: 10
            },
            // when window width is >= 1024px
            1000: {
                slidesPerView: 4,
                spaceBetween: 20
            },
            // when window width is >= 1400px
            1400: {
                slidesPerView: 6,
                spaceBetween: 20
            },
            // when window width is >= 1920px
            1920: {
              slidesPerView: 8,
              spaceBetween: 20
            }

        }
    });
});
